import {
    OPERATOR_LOCATION_START,
    OPERATOR_LOCATION_SUCCESS,
    OPERATOR_LOCATION_ERROR,
} from "Constant";

const initialState = {
    loading: false,
    data: [],
  };
  
  export default function LocationReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case OPERATOR_LOCATION_START:
        return {
          ...state,
          loading: true,
        };
      case OPERATOR_LOCATION_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case OPERATOR_LOCATION_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  